import { EditorServiceClient } from 'pbts/c1/api/editor/v1/editor.client'
import { createUnaryApi } from './lib/createUnaryApi'

export const editorService = createUnaryApi(
    EditorServiceClient,
    'validateCEL',
)

export const editorSchemaService = createUnaryApi(
    EditorServiceClient,
    'getCELSchema',
)
